export default __webpack_public_path__ + "media/images/features/toyono/osaka_area-794b3d0b86bd8cdab07438c7767942fd.png";